// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__ew7us","message":"Modal_message__unPHx","header":"Modal_header__jSGf1","body":"Modal_body__bU++e","row":"Modal_row__wcm4U","footer":"Modal_footer__WjQv1"};